import { Component, OnInit } from '@angular/core';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-finanzastabs',
    templateUrl: './finanzas-tabs.component.html',
    styleUrls: ['./finanzas-tabs.component.css'],
    standalone: false
})
export class FinanzastabsComponent implements OnInit {
  routes: object[];

  isSelected = false;
  isResponsive: boolean;

  constructor(
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: 'Bancos', link: '/finance/bankaccounts', enable: true },
      { label: 'Caja/Efectivo', link: '/finance/cash', enable: true },
      { label: 'Pol. Crédito', link: '/finance/creditfacility', enable: true },
      { label: 'Tarj. Débito', link: '/finance/debitcard', enable: true },
      { label: 'Tarj. Crédito', link: '/finance/creditcard', enable: true },
      { label: 'Prestamos', link: '/finance/loans', enable: true },
      { label: 'Creditos', link: '/finance/credits', enable: true },
      { label: 'Conciliación', link: '/finance/reconciliation/bank/list', enable: true },
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }
}
